// #1980 — reported live at WEC (bug #157): the scribe header showed a red
// "1 unsynced ride" badge (UnsyncedRidesIndicator.jsx, driven off
// manualRides.js's localStorage mirror) and a "1 sync issue, retrying" chip
// (SyncStatus.jsx, driven off the outbox's errorSync count) for the SAME
// ride's createRide op at the same time. The two components are separate
// trees reading separate state, so nothing stopped them disagreeing.
//
// Once a createRide op has surfaced as an error in the outbox, the
// sync-issue chip already reports it — by name, with a retry/discard path —
// so it must not ALSO inflate the unsynced-rides count. This function is
// the one place that de-dupes the two: a manual ride only counts as
// "unsynced" while it lacks a serverId AND its createRide op has not (yet)
// surfaced as an error. A ride whose op never reached the outbox at all
// (manualRides.js's own note on why serverId, not the outbox, is
// authoritative for detecting a lost write) is untouched by this — it is
// never in `erroredRideKeys` either, so it still counts.
// The single filter both the chip's count AND its popover list must go
// through — UnsyncedRidesIndicator.jsx used to read this same exclusion for
// the count (via unsyncedManualRideCount below) but filter its popover list
// straight off the unfiltered subscribeManualRides feed, so the header could
// read "1 unsynced ride" over a popover listing two: the errored one the
// count correctly excluded was still in the list it opened onto.
export function unsyncedManualRides(manualRides, erroredRideKeys) {
  return manualRides.filter(
    (ride) => !ride.serverId && !erroredRideKeys.has(ride.id),
  );
}

export function unsyncedManualRideCount(manualRides, erroredRideKeys) {
  return unsyncedManualRides(manualRides, erroredRideKeys).length;
}
